import React from 'react';

// SVGs inline em vez de emoji de bandeira: o emoji de bandeira (par de
// "regional indicator" Unicode) nao renderiza de forma confiavel em todos os
// navegadores/SO — no Windows em particular, varias combinacoes de
// navegador+fonte mostram so as duas letras ou um retangulo vazio no lugar
// da bandeira. SVG renderiza igual em qualquer lugar.
const commonProps = {
  width: 20,
  height: 15,
  viewBox: '0 0 20 15',
  'aria-hidden': true as const,
  style: { borderRadius: '2px', flexShrink: 0 },
};

export function FlagBR(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...commonProps} {...props}>
      <rect width="20" height="15" fill="#009c3b" />
      <polygon points="10,2 18,7.5 10,13 2,7.5" fill="#ffdf00" />
      <circle cx="10" cy="7.5" r="3.2" fill="#002776" />
    </svg>
  );
}

export function FlagUS(props: React.SVGProps<SVGSVGElement>) {
  const stripeHeight = 15 / 13;
  // 13 listras (7 vermelhas + 6 brancas alternadas) cobrindo a altura toda —
  // a versao anterior so desenhava as 7 vermelhas, sem alternar com branco e
  // sem cobrir os ~2px finais da bandeira.
  const stripes = Array.from({ length: 13 }, (_, i) => (
    <rect
      key={i}
      y={i * stripeHeight}
      width="20"
      height={stripeHeight}
      fill={i % 2 === 0 ? '#b22234' : '#fff'}
    />
  ));
  const starRows = [0, 1, 2, 3, 4, 5, 6];
  const starCols = [0, 1, 2, 3];
  return (
    <svg {...commonProps} {...props}>
      {stripes}
      <rect width="8.6" height={stripeHeight * 7} fill="#3c3b6e" />
      {starRows.map((row) =>
        starCols.map((col) => {
          const offset = row % 2 === 0 ? 0 : 1.075;
          return (
            <circle
              key={`${row}-${col}`}
              cx={0.9 + offset + col * 2.15}
              cy={0.75 + row * 1.5}
              r="0.35"
              fill="#fff"
            />
          );
        })
      )}
    </svg>
  );
}

export function FlagES(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...commonProps} {...props}>
      <rect width="20" height="15" fill="#aa151b" />
      <rect y="3.75" width="20" height="7.5" fill="#f1bf00" />
    </svg>
  );
}

export const FLAG_COMPONENTS: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  pt: FlagBR,
  en: FlagUS,
  es: FlagES,
};
